import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const Seo = ({ description, lang, meta, title, schemaMarkup }) => {

  const { site } = useStaticQuery(
     graphql`
       query {
         site {
           siteMetadata {
             title
             description
           }
         }
       }
     `
   )

  const metaDescription = description || site.siteMetadata.description
  const metaTitle = title || site.siteMetadata.title
  const commonSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "image": "https://www.engineeredmetalbuildings.com/static/b81f2bb5f87a3992879586deaa81d02f/88ed0/logo.webp",
    "url": "https://www.engineeredmetalbuildings.com/",
    "sameAs": [
      "https://maps.app.goo.gl/yabxaKrf3LRjxD9F8",
      "https://www.embmetalbuildings.com",
      "https://www.engineeredmetalbuildings.com/idaho/",
      "https://www.bbb.org/us/id/heyburn/profile/metal-building-contractors/emb-metal-buildings-llc-idaho-1296-1000182247"
    ],
    "logo": "https://www.engineeredmetalbuildings.com/static/b81f2bb5f87a3992879586deaa81d02f/88ed0/logo.webp",
    "name": "EMB Metal Buildings, LLC",
    "description": "At EMB Metal Buildings, we provide a wide range of strong, durable, and affordable structures to meet all your storage needs. Order your building today!",
    "email": "sales@embmetalbuildings.com",
    "telephone": "(208) 572-1441",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "340 Centennial Drive",
      "addressLocality": "Heyburn",
      "addressRegion": "ID",
      "postalCode": "83336",
      "addressCountry": "US"
    }
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}

      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      {/* {schemaMarkup && 
        <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>
      } */}
      {schemaMarkup ? (
        <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>
      ) : (
        <script type="application/ld+json">{JSON.stringify(commonSchema)}</script>
      )}
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Seo